// src/services/salesEstimateService.js
import apiClient from './API';

// --- BASKET CRUD ---
export const listSalesEstimateBaskets = async (accountId) => {
    const params = accountId ? { accountId } : {};
    const response = await apiClient.get('/sales-estimate/baskets', { params });
    return response.data;
};

export const getSalesEstimateBasket = async (id) => {
    const response = await apiClient.get(`/sales-estimate/baskets/${id}`);
    return response.data;
};

export const createSalesEstimateBasket = async (basket) => {
    const response = await apiClient.post('/sales-estimate/baskets', basket);
    return response.data;
};

export const updateSalesEstimateBasket = async (id, data) => {
    try {
        const res = await apiClient.put(`/amazon/baskets/sales/${id}`, data);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error updating Sales Estimate Basket');
    }
};

export const deleteSalesEstimateBasket = async (id) => {
    try {
        const res = await apiClient.delete(`/amazon/baskets/sales/${id}`);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error deleting Sales Estimate Basket');
    }
};

export const getAmazonEvents = async () => {
    try {
        const res = await apiClient.get('/analysis/amazon-events');
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error fetching Amazon Events');
    }
};

export const createAmazonEvent = async (data) => {
    try {
        const res = await apiClient.post('/analysis/amazon-events', data);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error creating Amazon Event');
    }
};

export const updateAmazonEvent = async (id, data) => {
    try {
        const res = await apiClient.put(`/analysis/amazon-events/${id}`, data);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error updating Amazon Event');
    }
};

export const deleteAmazonEvent = async (id) => {
    try {
        const res = await apiClient.delete(`/analysis/amazon-events/${id}`);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Error deleting Amazon Event');
    }
};

// --- SALES ESTIMATE QUERY ---
export const analyzeSalesEstimate = async ({ asins, basketId, marketplace = 'us', startDate, endDate }) => {
    const body = {};
    if (asins) body.asins = asins;
    if (basketId) body.basketId = basketId;
    if (marketplace) body.marketplace = marketplace;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    const response = await apiClient.post('/analysis/sales-estimate', body);
    return response.data;
};
